import { render, staticRenderFns } from "./LavorazioniCards.vue?vue&type=template&id=00455655"
import script from "./LavorazioniCards.vue?vue&type=script&lang=ts"
export * from "./LavorazioniCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00455655')) {
      api.createRecord('00455655', component.options)
    } else {
      api.reload('00455655', component.options)
    }
    module.hot.accept("./LavorazioniCards.vue?vue&type=template&id=00455655", function () {
      api.rerender('00455655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LavorazioniCards.vue"
export default component.exports